import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/storage'

const firebaseConfig = {
    apiKey: "AIzaSyBs65tNVw34IorPSmZpnNWshf48TC60bQY",
    authDomain: "golf-67815.firebaseapp.com",
    databaseURL: "https://golf-67815.firebaseio.com",
    projectId: "golf-67815",
    storageBucket: "golf-67815.appspot.com",
    messagingSenderId: "60725065172",
    appId: "1:60725065172:web:b1bf2a7b7b7e00e7",
  };
  // Initialize Firebase
firebase.initializeApp(firebaseConfig);

export {firebase}
